module.exports = __webpack_public_path__ + "b1811943b9c1ab56dde164f9c3fd084c.jpg";